import { render } from "./ScreenToggle.vue?vue&type=template&id=beb3fcf4&scoped=true"
import script from "./ScreenToggle.vue?vue&type=script&lang=js"
export * from "./ScreenToggle.vue?vue&type=script&lang=js"

import "./ScreenToggle.vue?vue&type=style&index=0&id=beb3fcf4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-beb3fcf4"

export default script